/**
 * Ленивая загрузка AR-оверлея — тот же паттерн, что IsoLazy: чанк нужен не
 * каждому посетителю, стартовый бандл его не платит. Чанк обычно уже в кеше:
 * его предзагружает выбор «AR-ведение» на экране ориентации.
 */
import type { ComponentType } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import { dropWarmup } from '../ar/permissions'
import { importChunk } from '../lazy-retry'
import { arSession } from '../state'

let cached: ComponentType | null = null

export function ArLazy() {
  // Ленивый инициализатор обязателен (см. IsoLazy): иначе Preact вызвал бы
  // компонент как функцию-инициализатор состояния.
  const [View, setView] = useState<ComponentType | null>(() => cached)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    if (View) return
    let alive = true
    void importChunk(() => import('../ar'))
      .then((m) => {
        cached = m.ArOverlay
        if (alive) setView(() => m.ArOverlay)
      })
      .catch(() => {
        // Чанк не приехал (оффлайн без кеша) — AR-сессию закрываем честно,
        // разогретая камера не должна гореть под пустым оверлеем.
        arSession.value = null
        dropWarmup()
        if (alive) setFailed(true)
      })
    return () => {
      alive = false
    }
  }, [View])

  if (failed || !View) return null
  return <View />
}
